import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import loadimg from "../images/loader_wish.gif";

const DeepProtectedRoute = ({ children, hasSubscription }) => {
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  useEffect(() => {

        if (
        hasSubscription &&
        typeof hasSubscription.deep_sub !== "undefined"
        ) {
        setChecking(false);
        }
    }, [hasSubscription]);

    if (checking) {
        return (
        <div className="page-loader">
          
        </div>
        );
    }
    if (hasSubscription.deep_sub === false) {
        return (
        <Navigate
            to="/cognitive32"
            replace
            state={{ from: location }}
        />
        );
    }

  return children;
};

export default DeepProtectedRoute;
